import React, { useEffect, useState } from "react";
import axios from "axios";
import { useOutletContext } from "react-router-dom";
import { currency_converter_inr, currency_converter_selected } from "../../utils/currencyUtils";
import NewEmployee from "./components/NewEmployee";
import ClosedRole from "./components/ClosedRole";
import NetAddWeekly from "./components/NetAddWeekly";
import EmployeeLeaves from "./components/EmployeeLeaves";
import EmployeeTravel from "./components/EmployeeTravel";
import NewClients from "./components/NewClients";
import ClosedRoleFY from "./components/ClosedRoleFY";
import Schedule from "./components/Schedule";
import RoleActivity from "./components/RoleActivity";

function Shift() {
    const user = JSON.parse(localStorage.getItem("user") || "{}");
    const REACT_APP_BASE_URL = process.env.REACT_APP_BASE_URL;
    const REACT_APP_API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
	const {setGlobalLoading, token } = useOutletContext();
	const [data, setData] = useState([]);
	const user_id = user.id;
	const get_shift_data = async () => {
		try {
		const response = await axios.post(
			`${REACT_APP_API_BASE_URL}/dashboard/get_shift_data`,
			{user_id},
			{ headers: { Authorization: `Bearer ${token}` } }
		);
		const d = response.data;
		const net_add_week_growth =
          ((response.data?.net_add_current_week?.[0]?.grand_total -
            response.data?.net_add_last_week?.[0]?.sum) /
            response.data?.net_add_last_week?.[0]?.sum) *
          100;
		 setData({
          ...d,
          net_add_week_growth,
		 });

		} catch (error) {
		setGlobalLoading(false);
		} finally {
		setGlobalLoading(false);
		}
	};
	useEffect(() => {
		get_shift_data();
	  }, [user_id]);
	

    return (
        <>
        <div className="content">
            <div className="card border-0">
                <div className="card-body d-flex align-items-center justify-content-between flex-wrap pb-1">
                    <div className="d-flex align-items-center mb-3">
                    <span className="avatar avatar-xl flex-shrink-0">
                        <img
                        src={`${REACT_APP_BASE_URL}files/media/${user.userpic}`}
                        className="rounded-circle"
                        alt="User Profile"
                        />
                    </span>
                    <div className="ms-3">
                        <h3 className="mb-2">
                        Welcome Back, {user.firstname + " " + user.lastname}
                        <a href="javascript:void(0);" className="edit-icon">
                            <i className="ti ti-edit fs-14"></i>
                        </a>
                        </h3>
                    </div>
                    </div>
                </div>
            </div>
			<div className="d-flex align-items-center mb-3 mt-3">
				<span className="me-2" style={{width:"30px",height:"4px",background:"#ff6a00",display:"inline-block",borderRadius:"3px"}}></span>
				<h3 className="mb-0">Business Pulse</h3>
			</div>
			<div class="row">
					<div className="col-xl-6 d-flex">
						<div className="card flex-fill">
							<div className="card-header">
								<div className="d-flex align-items-center flex-wrap row-gap-2">
									<i className="ti ti-circle-check fs-18 text-primary me-2"></i>
									<h5>Role Closures</h5>
								</div>
							</div>
							<div className="card-body" style={{ maxHeight: "260px", overflowY: "auto" }}>
									<ClosedRole chart_data={data?.closed_roles} />
							</div>
						</div>
					</div>
					<div className="col-xl-6 d-flex">
						<div className="card flex-fill">
							<div className="card-header">
								<div className="d-flex align-items-center flex-wrap row-gap-2">
									<i className="ti ti-trending-up fs-18 text-primary me-2"></i>
									<h5>Weekly Net Add</h5>
								</div>
							</div>
							<div className="card-body" style={{ maxHeight: "260px", overflowY: "auto" }}>
								<div className="card shadow-none mb-2">
									<div className="card-body">

									<div className="w-100">
										<div className="w-100">

										<h4 className="fs-16 fw-semibold mb-1">
											{currency_converter_selected(data?.net_add_current_week?.[0]?.grand_total || 0)}
										</h4>

										<p className="text-muted fs-13 mb-2">
											<span
											className={`fs-13 fw-light ${
												data?.net_add_week_growth > 0
												? "text-success"
												: "text-danger"
											}`}
											>
											<i
												className={`fa-solid me-1 ${
												data?.net_add_week_growth > 0
													? "fa-arrow-trend-up"
													: "fa-arrow-trend-down"
												}`}
											></i>
											{Number(data?.net_add_week_growth || 0).toFixed(2)}%
											</span>
										</p>

										{/* IMPORTANT */}
										<div className="w-100">
											<NetAddWeekly chart_data={data?.net_add_current_week} />
										</div>

										</div>
									</div>

									</div>
								</div>
								</div>
						</div>
					</div>
			</div>

			<div className="d-flex align-items-center mb-3 mt-3">
				<span className="me-2" style={{width:"30px",height:"4px",background:"#ff6a00",display:"inline-block",borderRadius:"3px"}}></span>
				<h3 className="mb-0">Announcements</h3>
			</div>
            <div class="row">
					<div className="col-xl-6 d-flex">
						<div className="card flex-fill">
							<div className="card-header">
								<div className="d-flex align-items-center flex-wrap row-gap-2">
									<i className="ti ti-user-plus fs-18 text-primary me-2"></i>
									<h5>New Joiners</h5>
								</div>
							</div>
							<div className="card-body" style={{ maxHeight: "260px", overflowY: "auto" }}>
									<NewEmployee chart_data={data?.new_employees} />
							</div>
						</div>
					</div>
					<div className="col-xl-6 d-flex">
						<div className="card flex-fill">
							<div className="card-header">
								<div className="d-flex align-items-center flex-wrap row-gap-2">
									<i className="ti ti-sparkles fs-18 text-primary me-2"></i>
									<h5>What's New</h5>
								</div>
							</div>
							<div className="card-body" style={{ maxHeight: "260px", overflowY: "auto" }}>
							<div className="card shadow-none mb-2">
								<div className="card-body">
								<div className="d-flex justify-content-between align-items-start flex-wrap gap-3">
									<div className="d-flex align-items-start">
									<div>
										<span className="fs-13 text-muted mb-1">29 October 2026</span>
										<div className="d-flex align-items-center flex-wrap">
										<h6 className="fs-16 fw-semibold mb-0 me-2">
											Candidate AI Sourcing Analysis
										</h6>
										</div>
										<p className="text-muted fs-13 mb-1">
											Get AI-powered sourcing scores and candidate assessments directly within your Workstation. Evaluate strengths, gaps, career progression, role fit and suggested interview questions against your search mandate. Access this under <b>AI Action Buttons</b> on the right side of your Workstation.
										</p>
									</div>
									</div>
								</div>
								</div>
							</div>
							<div className="card shadow-none mb-2">
								<div className="card-body">
								<div className="d-flex justify-content-between align-items-start flex-wrap gap-3">
									<div className="d-flex align-items-start">
									<div>
										<span className="fs-13 text-muted mb-1">29 October 2026</span>
										<div className="d-flex align-items-center flex-wrap">
										<h6 className="fs-16 fw-semibold mb-0 me-2">
											Automated Outreach – Stage 1
										</h6>
										</div>
										<p className="text-muted fs-13 mb-1">
											Reach out to candidates faster with automated LinkedIn and email outreach. Draft and send personalised messages, with weekly follow-ups for each candidate, helping you stay engaged without manually tracking every interaction.
										</p>
									</div>
									</div>
								</div>
								</div>
							</div>
							<div className="card shadow-none mb-2">
								<div className="card-body">
								<div className="d-flex justify-content-between align-items-start flex-wrap gap-3">
									<div className="d-flex align-items-start">
									<div>
										<span className="fs-13 text-muted mb-1">30 September 2026</span>
										<div className="d-flex align-items-center flex-wrap">
										<h6 className="fs-16 fw-semibold mb-0 me-2">
											Import Excel to Workstations
										</h6>
										</div>
										<p className="text-muted fs-13 mb-1">
											Already have a candidate mapping in Excel? Import it into your Workstation in just a few clicks! PINE can capture candidate details, notes, reporting structures, compensation information and candidate statuses, saving you hours of manual data entry.
										</p>
									</div>
									</div>
								</div>
								</div>
							</div>
							<div className="card shadow-none mb-2">
								<div className="card-body">
								<div className="d-flex justify-content-between align-items-start flex-wrap gap-3">
									<div className="d-flex align-items-start">
									<div>
										<span className="fs-13 text-muted mb-1">30 September 2026</span>
										<div className="d-flex align-items-center flex-wrap">
										<h6 className="fs-16 fw-semibold mb-0 me-2">
											Ask PINE
										</h6>
										</div>
										<p className="text-muted fs-13 mb-1">
											Meet Ask PINE, your AI-powered assistant! Simply ask questions in natural language to retrieve information, generate reports, find candidates or get help navigating PINE.
										</p>
									</div>
									</div>
								</div>
								</div>
							</div>
							<div className="card shadow-none mb-2">
								<div className="card-body">
								<div className="d-flex justify-content-between align-items-start flex-wrap gap-3">
									<div className="d-flex align-items-start">
									<div>
										<span className="fs-13 text-muted mb-1">18 Aug 2026</span>
										<div className="d-flex align-items-center flex-wrap">
										<h6 className="fs-16 fw-semibold mb-0 me-2">
											Candidate Profiling
										</h6>
										</div>
										<p className="text-muted fs-13 mb-1">
											PINE can now update candidate data in near real time. Open a candidate profile and click “<b>LI Update</b>” to pull their latest experience within seconds. You can also use <b>Profiling</b> to generate the candidate’s profile slide directly in <b>PPTX format</b>.
										</p>
									</div>
									</div>
								</div>
								</div>
							</div>
							<div className="card shadow-none mb-2">
								<div className="card-body">
								<div className="d-flex justify-content-between align-items-start flex-wrap gap-3">
									<div className="d-flex align-items-start">
									<div>
										<span className="fs-13 text-muted mb-1">18 Aug 2026</span>
										<div className="d-flex align-items-center flex-wrap">
										<h6 className="fs-16 fw-semibold mb-0 me-2">
											Search
										</h6>
										</div>
										<p className="text-muted fs-13 mb-1">
											Go to <b>Candidates → Search</b> to find candidates on PINE. Simply <b>type or speak your search brief</b>, and PINE will find the most relevant candidates for you.
										</p>
									</div>
									</div>
								</div>
								</div>
							</div>
							<div className="card shadow-none mb-2">
								<div className="card-body">
								<div className="d-flex justify-content-between align-items-start flex-wrap gap-3">
									<div className="d-flex align-items-start">
									<div>
										<span className="fs-13 text-muted mb-1">18 Aug 2026</span>
										<div className="d-flex align-items-center flex-wrap">
										<h6 className="fs-16 fw-semibold mb-0 me-2">
											Approvals
										</h6>
										</div>
										<p className="text-muted fs-13 mb-1">
											Approve <b>leaves and reimbursements</b> directly from PINE by clicking the <b>Approvals icon</b> on the top-left of your screen.
										</p>
									</div>
									</div>
								</div>
								</div>
							</div>
							<div className="card shadow-none mb-2">
								<div className="card-body">
								<div className="d-flex justify-content-between align-items-start flex-wrap gap-3">
									<div className="d-flex align-items-start">
									<div>
										<span className="fs-13 text-muted mb-1">18 Aug 2026</span>
										<div className="d-flex align-items-center flex-wrap">
										<h6 className="fs-16 fw-semibold mb-0 me-2">
											Workstation
										</h6>
										</div>
										<p className="text-muted fs-13 mb-1">
											Customise your <b>Workstation columns</b> based on the information you want to see and how you prefer to work.
										</p>
									</div>
									</div>
								</div>
								</div>
							</div>
							<div className="card shadow-none mb-2">
								<div className="card-body">
								<div className="d-flex justify-content-between align-items-start flex-wrap gap-3">
									<div className="d-flex align-items-start">
									<div>
										<span className="fs-13 text-muted mb-1">05 Jun 2026</span>
										<div className="d-flex align-items-center flex-wrap">
										<h6 className="fs-16 fw-semibold mb-0 me-2">
											GDPR Consent Automation
										</h6>
										</div>
										<p className="text-muted fs-13 mb-1">
										  Automatically trigger, track, and manage candidate GDPR consent from your workstation. Simply verify the candidate's email address when changing their status to Briefed.
										</p>

									</div>
									</div>
								</div>
								</div>
							</div>
							<div className="card shadow-none mb-2">
								<div className="card-body">
								<div className="d-flex justify-content-between align-items-start flex-wrap gap-3">
									<div className="d-flex align-items-start">
									<div>
										<span className="fs-13 text-muted mb-1">05 Jun 2026</span>
										<div className="d-flex align-items-center flex-wrap">
										<h6 className="fs-16 fw-semibold mb-0 me-2">
											Candidate Dossier from Recordings & Notes
										</h6>
										</div>
										<p className="text-muted fs-13 mb-1">
										  Upload interview recordings and notes against each candidate to generate a standardised candidate dossier in seconds.
										</p>

									</div>
									</div>
								</div>
								</div>
							</div>
							<div className="card shadow-none mb-2">
								<div className="card-body">
								<div className="d-flex justify-content-between align-items-start flex-wrap gap-3">
									<div className="d-flex align-items-start">
									<div>
										<span className="fs-13 text-muted mb-1">03 Mar 2026</span>
										<div className="d-flex align-items-center flex-wrap">
										<h6 className="fs-16 fw-semibold mb-0 me-2">
											Search Universe Now Available on Your Workstation
										</h6>
										</div>
										<p className="text-muted fs-13 mb-1">
										  Follow the guided steps to source relevant candidates directly from LinkedIn and save them instantly to your roles.
										</p>

									</div>
									</div>
								</div>
								</div>
							</div>
							<div className="card shadow-none mb-2">
								<div className="card-body">
								<div className="d-flex justify-content-between align-items-start flex-wrap gap-3">
									<div className="d-flex align-items-start">
									<div>
										<span className="fs-13 text-muted mb-1">03 Mar 2026</span>
										<div className="d-flex align-items-center flex-wrap">
										<h6 className="fs-16 fw-semibold mb-0 me-2">
											PINE 2.0: End-to-End Workflow Is Live
										</h6>
										</div>
										<p className="text-muted fs-13 mb-1">
										From managing clients to powering your workstation — everything now runs seamlessly in one unified system.
										</p>

									</div>
									</div>
								</div>
								</div>
							</div>
							</div>
						</div>
					</div>
			</div>

			<div class="row">
					<div className="col-xl-4 d-flex">
						<div className="card flex-fill">
							<div className="card-header">
								<div className="d-flex align-items-center flex-wrap row-gap-2">
									<i className="ti ti-plane fs-18 text-primary me-2"></i>
									<h5>Leave & Travel</h5>
								</div>
							</div>
							<div className="card-body" style={{ maxHeight: "260px", overflowY: "auto" }}>
								<div className="card shadow-none mb-2">
									<div className="card-body">
									<div className="w-100">
										<div className="w-100">
										<p className="text-muted fs-13 mb-2">
											On Leave ({data?.employees_leaves?.length || 0})
										</p>
										<div className="w-100">
											<EmployeeLeaves chart_data={data?.employees_leaves} />
										</div>
										</div>
									</div>
									</div>
								</div>
								<div className="card shadow-none mb-2">
									<div className="card-body">
									<div className="w-100">
										<div className="w-100">
										<p className="text-muted fs-13 mb-2">
											On Travel ({data?.employees_travel?.length || 0})
										</p>
										<div className="w-100">
											<EmployeeTravel chart_data={data?.employees_travel} />
										</div>
										</div>
									</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="col-xl-8 d-flex">
						<div className="card flex-fill">
							<div className="card-header">
								<div className="d-flex align-items-center flex-wrap row-gap-2">
									<i className="ti ti-users fs-18 text-primary me-2"></i>
									<h5>New Clients</h5>
								</div>
							</div>
							<div className="card-body" style={{ maxHeight: "260px", overflowY: "auto" }}>
									<NewClients chart_data={data?.new_clients} />
							</div>
						</div>
					</div>
			</div> 
			<div className="d-flex align-items-center mb-3 mt-3">
				<span className="me-2" style={{width:"30px",height:"4px",background:"#ff6a00",display:"inline-block",borderRadius:"3px"}}></span>
				<h3 className="mb-0">Personal Performance</h3>
			</div>									
			<div class="row">
					<div className="col-xl-6 d-flex">
						<div className="card flex-fill">
							<div className="card-header">
								<div className="d-flex align-items-center flex-wrap row-gap-2">
									<i className="ti ti-chart-column fs-18 text-primary me-2"></i>
									<h5>Role Closures — This Financial Year</h5>
								</div>
							</div>
							<div className="card-body" style={{ maxHeight: "300px", overflowY: "auto" }}>
									<ClosedRoleFY chart_data={data?.closed_roles_this_year} />
							</div>
						</div>
					</div>
					<div className="col-xl-6 d-flex">
						<div className="card flex-fill">
							<div className="card-header">
								<div className="d-flex align-items-center flex-wrap row-gap-2">
									<i className="ti ti-calendar fs-18 text-primary me-2"></i>
									<h5>Upcoming Schedule</h5>
								</div>
							</div>
							<div className="card-body" style={{ maxHeight: "260px", overflowY: "auto" }}>
								<Schedule chart_data={data?.schedule} />
							</div>
						</div>
					</div>
			</div>

			<div class="row">
					<div className="col-xl-12 d-flex">
						<div className="card flex-fill">
							<div className="card-header">
								<div className="d-flex align-items-center flex-wrap row-gap-2">
									<i className="ti ti-list-check fs-18 text-primary me-2"></i>
									<h5>Latest Tasks — Active Roles</h5>
								</div>
							</div>
							<div className="card-body" style={{ maxHeight: "300px", overflowY: "auto" }}>
									<RoleActivity chart_data={data?.role_activity} />
							</div>
						</div>
					</div>
			</div>      
        </div>
        </>
    );
}

export default Shift;